import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Shell } from "../../components/Shell";
import { useLang } from "../../lib/i18n";
import { useAuth } from "../../lib/auth";
import { api } from "../../lib/api";
import { LayoutDashboard, Users, Wallet, FileCheck2, ScrollText, BarChart3, Palette, CreditCard } from "lucide-react";
import Overview from "./Overview";
import Members from "./Members";
import Finance from "./Finance";
import Approvals from "./Approvals";
import Audit from "./Audit";
import Reports from "./Reports";
import Branding from "./Branding";
import Subscription from "./Subscription";

export default function TenantApp() {
  const { t } = useLang();
  const { user } = useAuth();
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    api.get("/tenant").then((r) => setTenant(r.data)).catch(() => {});
  }, []);

  const items = [
    { to: "/admin", end: true, icon: LayoutDashboard, label: t("dash.overview"), testid: "nav-tenant-overview" },
    { to: "/admin/members", icon: Users, label: t("dash.members"), testid: "nav-tenant-members" },
    { to: "/admin/finance", icon: Wallet, label: t("dash.finance"), testid: "nav-tenant-finance" },
    { to: "/admin/approvals", icon: FileCheck2, label: t("dash.approvals"), testid: "nav-tenant-approvals" },
    { to: "/admin/reports", icon: BarChart3, label: t("dash.reports"), testid: "nav-tenant-reports" },
    { to: "/admin/audit", icon: ScrollText, label: t("dash.audit"), testid: "nav-tenant-audit" },
    { to: "/admin/branding", icon: Palette, label: t("dash.branding"), testid: "nav-tenant-branding" },
    { to: "/admin/subscription", icon: CreditCard, label: t("dash.subscription"), testid: "nav-tenant-subscription" },
  ];

  return (
    <Shell
      items={items}
      brand={tenant?.branding?.brand_name || tenant?.name || "Koperasi"}
      subtitle={tenant ? `${tenant.slug}.kopera.app` : ""}
      testid="tenant-admin-portal"
    >
      <Routes>
        <Route index element={<Overview />} />
        <Route path="members" element={<Members />} />
        <Route path="finance" element={<Finance />} />
        <Route path="approvals" element={<Approvals />} />
        <Route path="reports" element={<Reports />} />
        <Route path="audit" element={<Audit />} />
        <Route path="branding" element={<Branding onSaved={setTenant} />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </Shell>
  );
}
